@if (hasScope()) {
  <avs-incidents-v2-table-desktop-filters
    (filterCriteriaChanged)="onFilterCriteriaChanged($event)"
    [dropdownFilters]="dropdownFilters()"
    [filtersEnabled]="true"
    [resolvedIncidentsLoading]="incidentsTable.store.isLoading()"
    [showColumnSelect]="showColumnSelect()"
    [showLocationFilters]="false"
    [tableId]="tableId()"
  />
  <app-incidents-v2-table
    [criteria]="selectedFilters()"
    [isInjected]="true"
    [isMobile]="isMobile()"
    [noDataText]="noDataText()"
    [sortCriteria]="criteriaStore.sortCriteria()"
    [tab]="criteriaStore.tab()"
    [tableId]="tableId()"
    #incidentsTable
  />
}
